import React from 'react';
import { useTranslation } from 'react-i18next';

// components
// import NavbarLink from './NavbarLink';
import LanguageBtn from '../LanguageBtn';
import HomeIcon from './Icons/HomeIcon';
import AboutIcon from './Icons/AboutIcon';
// import TermsIcon from './Icons/TermsIcon';
// import PrivacyIcon from './Icons/PrivacyIcon';
import ContactIcon from './Icons/ContactIcon';
import StoresIcon from './Icons/StoresIcon';
import SolutionsIcon from './Icons/SolutionsIcon';
import CollectionsCenter from './Icons/CollectionsCenter';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import MaterialsIcon from './Icons/MaterialsIcon';
import TermsIcon from './Icons/TermsIcon';
import LanguageIcon from './Icons/LanguageIcon';

const NavbarLink = ({ title, icon, path, setShowNav }) => {
  return (
    <NavLink
      className="nav__link"
      to={`/${path}`}
      onClick={() => setShowNav(false)}
    >
      {icon}
      <span className="">{title}</span>
    </NavLink>
  );
};

export default function Nav({ setShowNav, onOpenTermsModal }) {
  const { t } = useTranslation();
  const { language } = useSelector((state) => state.lang);

  const navLinks = [
    {
      key: 1,
      name: t('header.menu.nav.home'),
      link: 'home',
      icon: <HomeIcon />,
    },
    {
      key: 2,
      name: t('header.menu.nav.solutions'),
      link: 'solutions',
      icon: <SolutionsIcon />,
    },
    {
      key: 3,
      name: t('header.menu.nav.collectionCenter'),
      link: 'stores',
      icon: <CollectionsCenter />,
    },
    {
      key: 4,
      name: t('header.menu.nav.materials'),
      link: 'supply-prices',
      icon: <MaterialsIcon />,
    },
    {
      key: 7,
      name: t('header.menu.nav.partner'),
      link: 'partnerships',
      icon: <MaterialsIcon />,
    },
    {
      key: 5,
      name: t('header.menu.nav.contactUs'),
      link: 'contact-us',
      icon: <ContactIcon />,
    },
    {
      key: 6,
      name: t('header.menu.nav.terms'),
      link: 'about-us',
      icon: <TermsIcon />,
    },

    // {
    //   key: 7,
    //   name: t('header.menu.nav.language'),
    //   link: 'about-us',
    //   icon: <LanguageIcon />,
    // },
  ];

  return (
    <nav className={`nav ${language === 'ar' ? 'nav-rtl' : 'nav-ltr'}`}>
      <ul className={`nav__list `}>
        {navLinks.map((ele) => {
          if (ele.key === 6) {
            return (
              <div className="nav__link" onClick={onOpenTermsModal}>
                {ele.icon}
                <span className="">{ele.name}</span>
              </div>
            );
          } else {
            return (
              <NavbarLink
                key={ele.key}
                title={ele.name}
                icon={ele.icon}
                path={ele.link}
                setShowNav={setShowNav}
              />
            );
          }
        })}
        <li>
          <LanguageBtn
            setShowNav={setShowNav}
            title={
              <div className="nav__link">
                <LanguageIcon />
                <span>{t('header.menu.nav.language')}</span>
              </div>
            }
          />
        </li>
      </ul>
    </nav>
  );
}
